import { useState, type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Headline from '../Elements/Headline'
import { Modal } from '../Elements/Modal'
import Text from '../Elements/Text'
import Button from '../Formik/Button'
import { useCreateBudget } from '../Sheets/lib/Hooks/Budget'
import { TaskType } from './lib/Enums/TaskType'
import { useSkipTask } from './lib/Hooks/Tasks'

const TaskBudgetCreate: FC = () => {
  const { t } = useTranslation('guide')
  const [showModal, toggleModal] = useState(false)
  const { mutate: markTaskAsSkipped } = useSkipTask()
  const { mutateAsync: createBudget } = useCreateBudget()
  const navigate = useNavigate()

  const completeTask = async () => {
    const budget = await createBudget()

    return navigate(`/budget/${budget.id}/`)
  }

  return (
    <>
      <Modal show={showModal} onHide={() => toggleModal(false)}>
        {(closeModal: any) => (
          <>
            <Headline size='2xl' className='mb-4'>
              {t('guide:taskCreateBudget.modal.title')}
            </Headline>
            <Text size='base' className='mb-4'>
              {t('guide:taskCreateBudget.modal.description1')}
            </Text>
            <Text size='base' className='mb-8'>
              {t('guide:taskCreateBudget.modal.description2')}
            </Text>
            <Button
              theme='blue'
              onClick={() => {
                markTaskAsSkipped(TaskType.BUDGET_CREATE)
                toggleModal(false)
                closeModal()
              }}
            >
              {t('guide:taskCreateBudget.modal.confirm')}
            </Button>
          </>
        )}
      </Modal>
      <div className='flex flex-col justify-between h-[calc(100%-28px)]'>
        <div className='mb-4'>
          <Headline size='3xl' className='mb-2'>
            {t('guide:taskCreateBudget.heading')}
          </Headline>
          <Text size='base'>{t('guide:taskCreateBudget.description')}</Text>
        </div>
        <div className='flex justify-between items-center'>
          <Button theme='ghost' onClick={() => toggleModal(true)}>
            {t('guide:taskCreateBudget.haveBudget')}
          </Button>
          <Button theme='blue' onClick={completeTask}>
            {t('guide:taskCreateBudget.start')}
          </Button>
        </div>
      </div>
    </>
  )
}

export default TaskBudgetCreate
